import React from 'react';
import { EverestRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

const repository = new EverestRepository();

class EverestHomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null
    };
  }

  componentDidMount() {
    repository.findMe({}, (data) => this.setState({ user: data }));
  }

  render() {
    const { user } = this.state;

    return (
      <>
        <NavigationBar user={user} location={this.props.location} />
        {user && (<>  
          <HomeTemplate user={user} />
        </>)}
      </>
    );
  }
}

const HomeTemplate = (props) => {
  const {user} = props;
  return (
    <div>
      {user && user.nickname && (<>
        <p style={{ padding: 10 }}>
          <b>{user.nickname}</b>님 환영합니다!<br />
        </p>
      </>)}
    </div>
  );
};

export { EverestHomePage };
